import { AxiosPromise, AxiosRequestConfig } from 'axios';
import useAxios from 'axios-hooks';
import {
  AxiosMethod,
  defaultAxiosOptions,
  serviceEndpoints,
} from '../../constants';
import {
  DataFiltersModel,
  PaginationModel,
  UserStatisticEntity,
} from '../../models';
import { ResponseValuesOverride } from '../../models/response-values-override';

type getUsersResult = [
  ResponseValuesOverride<PaginationModel<UserStatisticEntity>>,
  (
    params: DataFiltersModel,
  ) => AxiosPromise<PaginationModel<UserStatisticEntity>>,
];

export function useGetUsersStatistic(
  url = serviceEndpoints.usersStatistic(),
): getUsersResult {
  const config: AxiosRequestConfig = {
    method: AxiosMethod.Get,
    url,
  };

  const [response, execute] = useAxios(config, { ...defaultAxiosOptions });

  const getUsers = (params: DataFiltersModel) => {
    try {
      return execute({
        ...config,
        params,
      });
    } catch (err) {}
  };

  return [response, getUsers];
}
